import type { CardTournamentItem, CardTournamentItemRaw, Items, TournamentItem, TournamentItemRaw } from '@/types';

export function tournamentsAdapter(tournaments: Items<TournamentItemRaw>): Items<TournamentItem> {
    return {
        ...tournaments,
        items: tournaments.items.map((item) => ({
            ...item,
            loadingItem: false,
            flip: false
        }))
    };
}
export function cardTournamentsAdapter(tournaments: Items<CardTournamentItemRaw>, isNewTournamentId?: number | null): Items<CardTournamentItem> {
    return {
        ...tournaments,
        items: tournaments.items.map((item) => ({
            ...item,
            loadingItem: false,
            isNewTournament: isNewTournamentId === item.id,
            flip: false
        }))
    };
}
